<app-page-title [title]="'Transfer Test Registration'"></app-page-title>

<div class="row">
    <div
        *ngIf="testRegInfo"
        class="col-md-12"
    >

        <div class="bg-policy">
            <h4>Test Transfer Policy</h4>
            <div *ngIf="brandId === BrandEnum.CELPIP && testRegInfo.isWebDelivery">
                <p>
                    You can transfer to another test sitting of the same type as originally registered for (CELPIP-General or CELPIP-General LS).
                    Transfers must be made at least 48 hours before the original test date for the Online test. The first transfer is free; the subsequent transfer fee is CAD $50 or equivalent (plus applicable taxes).
                </p>
                <p>Please note: If you have made arrangements for special accommodations, please contact us at specialaccommodations@celpip.ca to make a transfer request. </p>
            </div>
            <div *ngIf="brandId === BrandEnum.CELPIP && !testRegInfo.isWebDelivery">
                <p>You can transfer to another test sitting of the same type as originally registered for.
                    Transfers must be made at least 7 days before the original test date. The first transfer is free; the subsequent transfer fee is CAD $50 or equivalent (plus applicable taxes).</p>
                <p>Please note: If you have made arrangements for special accommodations, please contact us at info@celpip.ca to make a transfer request.</p>
            </div>
            <div *ngIf="brandId === BrandEnum.CAEL && testRegInfo.isWebDelivery">
                <p>You can transfer to another test sitting of the same type as originally registered for (CAEL at a test centre or CAEL Online).</p>
                <p>Transfers must be made at least 48 hours before the original test date for the Online test. The first transfer is free; the subsequent transfer fee is CAD $50 or equivalent (plus applicable taxes).</p>
                <p>Please note: If you have made arrangements for special accommodations, please contact us at <a
                        href="mailto:info@cael.ca"
                        target="_top"
                    >info@cael.ca</a> to make a transfer request.</p>
            </div>
            <div *ngIf="brandId === BrandEnum.CAEL && !testRegInfo.isWebDelivery">
                <p>
                    You can transfer to another test sitting for the same type of test that you originally registered for.
                    If you would like to transfer to CAEL Online, please register and pay for that test online, and then
                    <a href="https://www.cael.ca/about-us/contact-us/">contact us</a> to have this particular registration cancelled.
                </p>
                <p>Transfers must be made at least 7 calendar days before the original test date. The fee to transfer is CAD 50.00 (plus applicable taxes).</p>
                <p>Please note: If you have made arrangements for special accommodations, please contact us at <a
                        href="mailto:info@cael.ca"
                        target="_top"
                    >info@cael.ca</a> to make a transfer request.</p>
            </div>
        </div>

        <br />
        <h4>
            Test Registration Number {{regId}}
        </h4>

        <div>
            <table class="table table-hover">
                <thead>
                    <tr>
                        <th>Test Date</th>
                        <th *ngIf="testRegInfo.isWebDelivery">(Time Zone)</th>
                        <th>Test Type</th>
                        <th *ngIf="!testRegInfo.isWebDelivery">Test Centre</th>
                        <th *ngIf="!testRegInfo.isWebDelivery">Test Centre Location</th>
                    </tr>
                </thead>
                <tbody>
                    <tr *ngIf="!testRegInfo.isWebDelivery">
                        <td>{{testRegInfo.testDateTime | date: 'MMMM d, y - EEEE h:mm a'}}</td>
                        <td>{{testRegInfo.testTypeName}}</td>
                        <td>{{testRegInfo.testCentreName}}</td>
                        <td>{{testRegInfo.testCentreLocation}}</td>
                    </tr>
                    <tr *ngIf="testRegInfo.isWebDelivery">
                        <td>{{convertedTestRegDateFromUTCToLocal | date: 'EEEE, MMMM d, y, h:mm a'}}</td>
                        <td>({{localTimeZone}})</td>
                        <td>{{testRegInfo.testTypeName}}</td>
                    </tr>
                </tbody>
            </table>
        </div>

        <h4>Transfer To</h4>
        <div
            class="row survey"
            *ngIf="!testRegInfo.isWebDelivery"
        >
            <div
                class="col-md-4"
                *ngIf="brandId === BrandEnum.CELPIP && testTypeId != TestTypeEnum.CELPIP_LS"
            >
                <div class="form-group surveyQuestion">
                    <label class="questionText">1. Select a country</label>
                    <select
                        id="sitting-selection-select-region-select"
                        class="form-control"
                        name="countryId"
                        [(ngModel)]="selectedCountry"
                        (change)="getCountrySittings()"
                    >
                        <option
                            *ngFor="let country of countries"
                            [ngValue]="country"
                        >
                            {{country.name}}
                        </option>
                    </select>
                </div>
            </div>
            <div
                class="col-md-4"
                *ngIf="brandId === BrandEnum.CELPIP && testTypeId == TestTypeEnum.CELPIP_LS"
            >
                <div class="form-group surveyQuestion">
                    <label class="questionText">1. Select a country</label>
                    <select
                        id="sitting-selection-select-region-select"
                        class="form-control"
                        name="countryId"
                        [(ngModel)]="selectedCountry"
                        (change)="getCountrySittings()"
                    >
                        <option
                            *ngFor="let country of countries"
                            [ngValue]="country"
                        >
                            {{country.name}}
                        </option>
                    </select>
                </div>
            </div>
            <div class="col-md-4">
                <div class="form-group surveyQuestion">
                    <label class="questionText">{{stepNumberRegion}}. Pick a region</label>
                    <select
                        class="form-control"
                        name="region"
                        [(ngModel)]="selectedRegion"
                        (change)="getRegionSittings()"
                    >
                        <option
                            *ngFor="let region of regions"
                            [ngValue]="region"
                        >
                            {{region.name}}
                        </option>
                    </select>
                </div>
            </div>
            <div
                *ngIf="showTestCentre"
                class="col-md-5"
            >
                <div
                    class="form-group surveyQuestion"
                    *ngIf="selectedRegion && !(!sittings || sittings.length < 1)"
                >
                    <label class="questionText">{{stepNumberTestCentre}}. Select a test centre</label>
                    <select
                        class="form-control"
                        name="centre"
                        [(ngModel)]="testCentre"
                        (change)="setTestCentre()"
                    >
                        <option
                            *ngFor="let testCentreInfo of testCentres"
                            [ngValue]="testCentreInfo"
                        >
                            {{testCentreInfo.testCentreName}}
                        </option>
                    </select>
                </div>
            </div>
        </div>
        <div class="row survey">
            <div class="col-md-9">
                <div
                    class="form-group surveyQuestion"
                    *ngIf="testCentre"
                >
                    <div *ngIf="testRegInfo.isWebDelivery">
                        <label class="questionText">Select a test sitting (test date time by time zone {{localTimeZone}})</label>
                        <select
                            class="form-control"
                            name="sittingId"
                            [(ngModel)]="sittingId"
                            (change)="getTransferFee()"
                        >
                            <option
                                *ngFor="let sittingInfo of sittingLocalDateMap | keyvalue"
                                [ngValue]="sittingInfo.key"
                            >
                                {{sittingInfo.value | date: 'EEEE, MMMM d, y, h:mm a'}}
                            </option>
                        </select>
                    </div>
                    <div *ngIf="!testRegInfo.isWebDelivery && sittingsForSelectedTestCentre.length > 0">
                        <label class="questionText">{{stepNumberSitting}}. Select a test sitting</label>
                        <select
                            class="form-control"
                            name="sittingId"
                            [(ngModel)]="sittingId"
                            (change)="getTransferFee()"
                        >
                            <option *ngIf="!sittingId"></option>
                            <option
                                *ngFor="let sittingInfo of sittingsForSelectedTestCentre"
                                [ngValue]="sittingInfo.id"
                            >
                                {{sittingInfo.testDateTimeTestCentre | date: 'EEEE, MMMM d, y, h:mm a'}}
                            </option>
                        </select>
                    </div>
                </div>
            </div>
        </div>
        <div
            class="row survey"
            *ngIf="transferPaymentReturned === true"
        >
            <div
                class="col-md-9"
                [ngSwitch]="transferPayment.canTransfer"
            >
                <span *ngSwitchCase="false">
                    <strong>Cannot transfer to the sitting selected because of the test registration transfer policy.</strong>
                </span>
                <label *ngIf="transferPayment.promotionAmount > 0">
                    You are transferring into a test sitting with a different test fee. Please note that the difference in the
                    test fee ({{transferPayment.promotionAmount | currency: transferPayment.currencyCode:  transferPayment.currencyCode + " "}} + Tax) will be applied in addition to the transfer fee.
                </label>
            </div>
        </div>
        <br />
        <button
            type="button"
            class="btn btn-primary"
            (click)="transferReg()"
            [disabled]="transferPaymentReturned === false || (!transferPayment || transferPayment.canTransfer === false)"
        >Add to Shopping Cart</button>
    </div>
</div>
<app-modal
    *ngIf="transferPayment"
    #confirmationModal
    title="Confirmation"
    body="{{confirmMessage}}"
    (clickPositive)="routeToShoppingCart()"
>
</app-modal>
